module.exports = __webpack_public_path__ + "assets/images/teacher-instruction-icon.004bec16afbd18765e1ff2ce31040717.svg";